import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as EntitiesActionTypes from '../../../entities/actionTypes'
import {arrayToMap, arrayToSet, filterMapByKey, filterMapByKeys} from '../../../atUtils'

const createReducer = (initAppData) => {
    let tab = initAppData.USER_MANAGEMENT.ACTIVE_TAB_NUM
    const initState = {
        activeTab: tab,
        viewerSettings: {
            allowedToManageAccountSettings: false,
            allowedToManageLeaveBalanceSettings: false,
            allowedToManageScope: false,
            assignedUserIds: null,
            hasAccessToScopeOfWork: false,
            hasAccessToUsers: false,
            showAccountSettings: true,
        }, // TODO move to global user settings
        licenseCounters: {
            actualCount: 0,
            allowedCount: 0,
            extraUsersCount: 0,
            licenseViolated: false,
            remainingCount: 1,
        },
        viewerManagementAssignmentsCounters: {
            customers: 0,
            projects: 0,
            tasks: 0
        },
        usersWithoutApprovers: [],
        userManagementData: {
            activeLeaveTypes: [],
            allUserGroups: [],
            overtimeRateCoefficient: 0,
            decimalSeparator: '.',
            dateFormat: '',
            defaultWorkSchedule: [],
            invertedDaysMap: {},
            weekStartDay: 1,
            permissionsTemplates: [],
            viewerSettings: {
                enabledFeatures: {},
                allowedToManageLeaveBalanceSettings: false,
                allowedToManageScope: false,
                hasAccessToScopeOfWork: false,
                hasAccessToUsers: false,
                allowedToManageAccountSettings: false,
                assignedUserIds: null,
                showAccountSettings: false
            },
            todayInViewerTimeZone: (new Date()).toJSON(),
            allTimeZoneGroups: [],
            allTimeZoneGroupOffsets: {},
        },
        groupsWithoutApprovers: [],
        usersList: initAppData.USER_MANAGEMENT.USERS_LIST ? arrayToMap(initAppData.USER_MANAGEMENT.USERS_LIST.list) : {},
        newUsersIdSet: {},
    }

    return handleActions({
        [ActionTypes.SET_ACTIVE_TAB]: (state, {payload: tab}) => ({
            ...state,
            activeTab: tab
        }),
        [ActionTypes.SET_USERS_WITHOUT_APPROVERS]: (state, {payload: usersWithoutApprovers}) => ({
            ...state,
            usersWithoutApprovers,
        }),
        [ActionTypes.SET_VIEWER_SETTINGS]: (state, {payload: viewerSettings}) => ({
            ...state,
            viewerSettings,
        }),
        [ActionTypes.SET_LICENSE_COUNTERS]: (state, {payload: licenseCounters}) => ({
            ...state,
            licenseCounters
        }),
        [ActionTypes.SET_NEW_USER_IDS]: (state, {payload: newUsersIdSet}) => ({
            ...state,
            newUsersIdSet,
        }),
        [ActionTypes.ADD_NEW_USER_IDS]: (state, {payload: ids}) => ({
            ...state,
            newUsersIdSet: {
                ...state.newUsersIdSet,
                ...arrayToSet(ids),
            }
        }),
        [ActionTypes.SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS]: (state, {payload: counters}) => ({
            ...state,
            viewerManagementAssignmentsCounters: counters,
        }),
        [ActionTypes.USERS_LIST_ADD]: (state, {payload: users}) => ({
            ...state,
            usersList: {
                ...state.usersList,
                ...arrayToMap(users),
            }
        }),
        [ActionTypes.USERS_LIST_REMOVE]: (state, {payload: id}) => ({
            ...state,
            usersList: filterMapByKey(state.usersList, id)
        }),
        [ActionTypes.USERS_LIST_SET]: (state, {payload: users}) => ({
            ...state,
            usersList: arrayToMap(users)
        }),
        [ActionTypes.USER_MANAGEMENT_DATA_SET]: (state, {payload: userManagementData}) => ({
            ...state,
            userManagementData: {...state.userManagementData, ...userManagementData}
        }),
        [ActionTypes.USERS_LIST_USER_GROUP_ID_UPDATE]: (state, {payload: {userId, userGroupId}}) => ({
            ...state,
            usersList: {
                ...state.usersList,
                [userId] : {
                    ...state.usersList[userId],
                    userGroupId
                }
            }
        }),
        [EntitiesActionTypes.USERS_REMOVE]: (state, {payload: ids}) => ({
            ...state,
            newUsersIdSet: filterMapByKeys(state.newUsersIdSet, ids),
        }),

    }, initState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/common/reducer.js